import Vue from 'vue';
import VueRouter from 'vue-router';
import DiscordTutorialView from './views/DiscordTutorialView/DiscordTutorialView.vue';

Vue.use(VueRouter);

const routes = [
    { path: '/', component: DiscordTutorialView },
    { path: '/:version/:lang', component: DiscordTutorialView },
];

export const router = new VueRouter({
    routes,
});
